// UI tokens
export const STATUS_STYLES = {
  pending_payment: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Awaiting Payment' },
  paid: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Paid - In Kitchen' },
  preparing: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Preparing' },
  ready: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Ready' },
  dispatched: { bg: 'bg-sky-100', text: 'text-sky-700', label: 'Dispatched' },
  on_the_way: { bg: 'bg-sky-100', text: 'text-sky-700', label: 'On the way' },
  picked_up: { bg: 'bg-green-100', text: 'text-green-700', label: 'Picked Up' },
  delivered: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Delivered' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelled' },
  refunded: { bg: 'bg-red-100', text: 'text-red-700', label: 'Refunded' },
};

export const EXPENSE_STATUS_STYLES = {
  pending: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Pending Approval' },
  approved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Approved' },
  rejected: { bg: 'bg-red-100', text: 'text-red-700', label: 'Rejected' }
};

export const TAB_ACTIVE_CLASSES = {
  pos: 'border-blue-500 text-blue-600 bg-blue-50',
  approvals: 'border-rose-500 text-rose-600 bg-rose-50',
  queue: 'border-orange-500 text-orange-600 bg-orange-50',
  kitchen: 'border-green-500 text-green-600 bg-green-50',
  history: 'border-purple-500 text-purple-600 bg-purple-50',
  riders: 'border-sky-500 text-sky-600 bg-sky-50',
  analytics: 'border-indigo-500 text-indigo-600 bg-indigo-50',
  eod: 'border-emerald-500 text-emerald-600 bg-emerald-50',
  expenses: 'border-rose-500 text-rose-600 bg-rose-50',
  myexpenses: 'border-teal-500 text-teal-600 bg-teal-50',
  inventory: 'border-amber-500 text-amber-600 bg-amber-50',
  complaints: 'border-red-500 text-red-600 bg-red-50',
  marketing: 'border-fuchsia-500 text-fuchsia-600 bg-fuchsia-50',
  finance: 'border-teal-500 text-teal-600 bg-teal-50',
};

// Complaint management log
export const COMPLAINT_ISSUE_TYPES = [
  { key: 'wrong-order', label: 'Wrong order' },
  { key: 'delayed-delivery', label: 'Delayed delivery' },
  { key: 'missing-item', label: 'Missing item' },
  { key: 'quality-issue', label: 'Food quality issue' },
  { key: 'staff-behaviour', label: 'Staff behaviour' },
  { key: 'billing-issue', label: 'Billing issue' },
  { key: 'other', label: 'Other' },
];

export const complaintIssueLabels = COMPLAINT_ISSUE_TYPES.reduce((acc, entry) => {
  acc[entry.key] = entry.label;
  return acc;
}, {});

export const COMPLAINT_STATUS_STYLES = {
  open: { bg: 'bg-red-100', text: 'text-red-700', label: 'Open' },
  in_progress: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'In Progress' },
  resolved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Resolved' },
};

// Marketing activity log
export const MARKETING_ACTIVITY_TYPES = [
  { key: 'social-post', label: 'Social media post' },
  { key: 'influencer', label: 'Influencer campaign' },
  { key: 'promotion', label: 'Promotion / discount' },
  { key: 'sms', label: 'SMS campaign' },
  { key: 'flyer', label: 'Flyers / print' },
  { key: 'radio', label: 'Radio / audio' },
  { key: 'other', label: 'Other' },
];

export const marketingTypeLabels = MARKETING_ACTIVITY_TYPES.reduce((acc, entry) => {
  acc[entry.key] = entry.label;
  return acc;
}, {});

export const methodLabels = { momo: 'MoMo', cash: 'Cash', card: 'Card', split: 'Split Payment', Unknown: 'Unknown' };

// Sales channels an order can come from. `detail` marks sources that need a
// follow-up entry: 'select' shows the online sub-channel list, 'text' shows a
// free-text "specify" input. 'website' is never picked at the POS — it is
// stamped automatically on orders placed through the customer website.
export const ORDER_SOURCES = [
  { key: 'walk-in', label: 'Walk-in' },
  { key: 'bolt-food', label: 'Bolt Food' },
  { key: 'hubtel', label: 'Hubtel' },
  { key: 'chowdeck', label: 'Chowdeck' },
  { key: 'online', label: 'Online', detail: 'select' },
  { key: 'referral', label: 'Referral' },
  { key: 'other', label: 'Other', detail: 'text' },
];

export const ONLINE_SOURCE_CHANNELS = ['WhatsApp', 'Phone call', 'TikTok', 'Instagram', 'Facebook', 'Other'];

// Order discounts. A discount is a percentage off the ITEMS subtotal only —
// packaging and delivery fees are never discounted. Admins apply one directly;
// everyone else can only request one, capped at STAFF_MAX_DISCOUNT_PERCENT, and
// an admin approves it from the Approvals tab before it takes effect.
export const STAFF_MAX_DISCOUNT_PERCENT = 10;
export const MAX_DISCOUNT_PERCENT = 100;

// 'other' takes a free-text detail, mirroring how ORDER_SOURCES handles it.
export const DISCOUNT_REASONS = [
  { key: 'staff-meal', label: 'Staff meal' },
  { key: 'regular-customer', label: 'Regular customer' },
  { key: 'service-recovery', label: 'Service recovery' },
  { key: 'bulk-order', label: 'Bulk order' },
  { key: 'promotion', label: 'Promotion' },
  { key: 'other', label: 'Other', detail: 'text' },
];

export const discountReasonLabels = DISCOUNT_REASONS.reduce((acc, entry) => {
  acc[entry.key] = entry.label;
  return acc;
}, {});

export const getDiscountReasonLabel = (reason, reasonDetail) => {
  const label = discountReasonLabels[reason] || reason || 'Unspecified';
  return reasonDetail ? `${label} (${reasonDetail})` : label;
};

export const orderSourceLabels = {
  'walk-in': 'Walk-in',
  'bolt-food': 'Bolt Food',
  hubtel: 'Hubtel',
  chowdeck: 'Chowdeck',
  online: 'Online',
  referral: 'Referral',
  website: 'Website',
  other: 'Other',
};

export const getOrderSourceLabel = (order) => {
  const label = orderSourceLabels[order?.orderSource] || order?.orderSource || 'Unknown';
  return order?.orderSourceDetail ? `${label} (${order.orderSourceDetail})` : label;
};

// Shared date filter option sets used by every tab that has a date filter
export const COMPACT_FILTER_OPTIONS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'week', label: 'Week' },
  { key: 'month', label: 'Month' },
  { key: 'all', label: 'All' },
  { key: 'custom', label: '📅 Date' },
];

export const FULL_FILTER_OPTIONS = [
  { key: 'today', label: 'Today', icon: '📅' },
  { key: 'yesterday', label: 'Yesterday', icon: '⏮️' },
  { key: 'last7days', label: 'Last 7 Days', icon: '📊' },
  { key: 'week', label: 'This Week', icon: '📈' },
  { key: 'last30days', label: 'Last 30 Days', icon: '📉' },
  { key: 'month', label: 'This Month', icon: '📋' },
  { key: 'quarter', label: 'This Quarter', icon: '🔄' },
  { key: 'year', label: 'This Year', icon: '📆' },
  { key: 'all', label: 'All Time', icon: '🗂️' },
  { key: 'custom', label: 'Custom Range', icon: '🗓️' },
];

// ============================================================
// DEFAULT DAILY INVENTORY
// These are the quantities restocked at the start of each stock day.
// dailyDefault = how many units to reset to at 11pm each day (INVENTORY_RESET_HOUR).
// lowStockThreshold = alert level during the day.
// ============================================================
export const DEFAULT_INVENTORY = [
  // Values sourced directly from komis_default_Inventory.docx, except Tsoofi,
  // Chili Rice and Sobolo (Small), which the owner moved to a standing daily
  // stock of 10 on 2026-08-14, and Tuna Tin, moved to a standing daily stock of
  // 5 on 2026-08-21.
  { id: 'kenkey',        name: 'Kenkey Ball',         unit: 'piece',   costPerUnit: 5.00,  dailyDefault: 120, lowStockThreshold: 20 },
  { id: 'chicken',       name: 'Chicken Piece',        unit: 'piece',   costPerUnit: 8.00,  dailyDefault: 40,  lowStockThreshold: 10 },
  { id: 'fish',          name: 'Fish Piece',           unit: 'piece',   costPerUnit: 12.00, dailyDefault: 40,  lowStockThreshold: 10 },
  { id: 'turkey',        name: 'Turkey Piece',         unit: 'piece',   costPerUnit: 10.00, dailyDefault: 40,  lowStockThreshold: 10 },
  { id: 'pork',          name: 'Pork Portion',         unit: 'portion', costPerUnit: 18.00, dailyDefault: 30,  lowStockThreshold: 10 },
  { id: 'gizzard',       name: 'Gizzard Portion',      unit: 'portion', costPerUnit: 12.00, dailyDefault: 35,  lowStockThreshold: 10 },
  { id: 'beef_sausage',  name: 'Beef Sausage',         unit: 'piece',   costPerUnit: 5.00,  dailyDefault: 20,  lowStockThreshold: 5  },
  { id: 'chicken_frank', name: 'Chicken Frank',        unit: 'piece',   costPerUnit: 4.00,  dailyDefault: 70,  lowStockThreshold: 10 },
  { id: 'omelette',      name: 'Omelette',             unit: 'piece',   costPerUnit: 4.00,  dailyDefault: 60,  lowStockThreshold: 30 },
  { id: 'sardine',       name: 'Sardine Tin',          unit: 'tin',     costPerUnit: 10.00, dailyDefault: 15,  lowStockThreshold: 5  },
  { id: 'komis_sauce',   name: 'Komis Sauce',          unit: 'portion', costPerUnit: 2.00,  dailyDefault: 60,  lowStockThreshold: 20 },
  { id: 'tuna',          name: 'Tuna Tin',             unit: 'tin',     costPerUnit: 18.00, dailyDefault: 5,   lowStockThreshold: 10 },
  { id: 'sobolo_small',  name: 'Sobolo (Small)',       unit: 'bottle',  costPerUnit: 4.00,  dailyDefault: 10,  lowStockThreshold: 10 },
  { id: 'sobolo_big',    name: 'Sobolo (Big)',         unit: 'bottle',  costPerUnit: 6.00,  dailyDefault: 0,   lowStockThreshold: 10 },
  { id: 'soft_drink',    name: 'Soft Drink',           unit: 'bottle',  costPerUnit: 5.00,  dailyDefault: 0,   lowStockThreshold: 20 },
  { id: 'bottled_water', name: 'Bottled Water',        unit: 'bottle',  costPerUnit: 2.00,  dailyDefault: 0,   lowStockThreshold: 30 },
  { id: 'red_fish',      name: 'Red Fish',             unit: 'piece',   costPerUnit: 15.00, dailyDefault: 0,   lowStockThreshold: 0  },
  // Renamed to Chili Rice; the id stays `assorted_rice` because the ordering
  // site and existing inventory rows key off it.
  { id: 'assorted_rice', name: 'Chili Rice Plate',     unit: 'plate',   costPerUnit: 12.00, dailyDefault: 10,  lowStockThreshold: 0  },
  { id: 'tsoofi',        name: 'Tsoofi',               unit: 'portion', costPerUnit: 35.00, dailyDefault: 10,  lowStockThreshold: 5  },
  { id: 'shrimps',       name: 'Shrimps',              unit: 'portion', costPerUnit: 20.00, dailyDefault: 0,   lowStockThreshold: 5  },
];

// Keep baseIngredients as an alias so existing code that references it still works
export const baseIngredients = DEFAULT_INVENTORY;

// Recipe definitions - what ingredients each menu item needs
export const menuRecipes = {
  "Regular chicken": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'chicken', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Regular fish": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Turkey delight": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'turkey', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Double k sardine": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'sardine', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Double k tuna": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'tuna', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Pork lovers": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'pork', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "Bossu": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'chicken', quantity: 1 },
    { ingredientId: 'gizzard', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "YOLO / Twa we num": [
    { ingredientId: 'kenkey', quantity: 3 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'chicken', quantity: 1 },
    { ingredientId: 'pork', quantity: 1 },
    { ingredientId: 'gizzard', quantity: 1 },
    { ingredientId: 'turkey', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'chicken_frank', quantity: 1 },
    { ingredientId: 'beef_sausage', quantity: 1 }
  ],
  "Cedi saver": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'chicken', quantity: 1 }
  ],
  "Beefy up": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'beef_sausage', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "Meatlovers (Pork)": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'pork', quantity: 1 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'turkey', quantity: 1 },
    { ingredientId: 'beef_sausage', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "Meatlovers (Gizzard)": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'gizzard', quantity: 1 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'turkey', quantity: 1 },
    { ingredientId: 'beef_sausage', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "Chili Rice": [
    { ingredientId: 'assorted_rice', quantity: 1 },
    { ingredientId: 'chicken', quantity: 1 }
  ],
  "Gizzard pack with 1 kenkey": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'gizzard', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "Gizzard pack with 2 kenkey": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'gizzard', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "Students Promo - Option 1": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'chicken', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 },
    { ingredientId: 'gizzard', quantity: 1 }
  ],
  "Students Promo - Option 2": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'turkey', quantity: 1 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "BBQ wings Promo": [
    { ingredientId: 'kenkey', quantity: 2 },
    { ingredientId: 'fish', quantity: 1 },
    { ingredientId: 'chicken', quantity: 4 },
    { ingredientId: 'omelette', quantity: 2 },
    { ingredientId: 'beef_sausage', quantity: 1 },
    { ingredientId: 'sobolo_small', quantity: 1 }
  ],
  // Extras
  "1 kenkey": [
    { ingredientId: 'kenkey', quantity: 1 }
  ],
  "1 omelette": [
    { ingredientId: 'omelette', quantity: 1 }
  ],
  "1 piece chicken": [
    { ingredientId: 'chicken', quantity: 1 }
  ],
  "1 piece fish": [
    { ingredientId: 'fish', quantity: 1 }
  ],
  "1 beef sausage": [
    { ingredientId: 'beef_sausage', quantity: 1 }
  ],
  "Extra komis sauce": [
    { ingredientId: 'komis_sauce', quantity: 1 }
  ],
  "1 kenkey + sauces": [
    { ingredientId: 'kenkey', quantity: 1 },
    { ingredientId: 'komis_sauce', quantity: 1 }
  ],
  "1 chicken sausage": [
    { ingredientId: 'chicken_frank', quantity: 1 }
  ],
  "1 tin sardine": [
    { ingredientId: 'sardine', quantity: 1 }
  ],
  "1 tin tuna": [
    { ingredientId: 'tuna', quantity: 1 }
  ],
  "1 bottle sobolo (small)": [
    { ingredientId: 'sobolo_small', quantity: 1 }
  ],
  "1 bottle sobolo (big)": [
    { ingredientId: 'sobolo_big', quantity: 1 }
  ],
  "1 turkey": [
    { ingredientId: 'turkey', quantity: 1 }
  ],
  "Pork": [
    { ingredientId: 'pork', quantity: 1 }
  ],
  "Gizzard": [
    { ingredientId: 'gizzard', quantity: 1 }
  ],
  "Soft drinks": [
    { ingredientId: 'soft_drink', quantity: 1 }
  ],
  "Bottled water": [
    { ingredientId: 'bottled_water', quantity: 1 }
  ],
  "1 plate of chili rice": [
    { ingredientId: 'assorted_rice', quantity: 1 }
  ],
  "Tsoofi": [
    { ingredientId: 'tsoofi', quantity: 1 }
  ],
  "Shrimps": [
    { ingredientId: 'shrimps', quantity: 1 }
  ]
};

// -----------------------------------------------------------------------------
// New-website-order alarm
// -----------------------------------------------------------------------------
// Orders placed on the customer site raise an audible, repeating alert so staff
// who are away from the tablet still notice them.

// The shop's alerting window, in the tablet's local time — Africa/Accra, which
// is UTC+0 year-round with no DST. Outside these hours the POS stays silent and
// the backend is expected to skip the push entirely (a notification shown while
// the screen is off plays the OS tone before any of our code runs, so quiet
// hours cannot be enforced on this side alone).
export const ALERT_HOURS = { start: 7, end: 20 };

// How often the chime repeats, and the hard stop. The cap exists so a forgotten
// tablet in an empty shop cannot ring until its battery dies.
export const ALERT_RING_INTERVAL_MS = 15000;
export const ALERT_RING_CAP_MS = 120000;

// An order older than this never raises the alarm. Without it, the full order
// fetch that runs on every login would treat months of website orders as new
// arrivals and the tablet would scream through the whole backlog.
export const ALERT_MAX_ORDER_AGE_MS = 10 * 60 * 1000;

// Statuses in which an order is still awaiting attention. Once it moves past
// these somebody has clearly picked it up, so the alarm stops even if nobody
// pressed the acknowledge button.
export const ALERT_ACTIVE_STATUSES = ['pending_payment', 'paid', 'preparing'];
